<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="$t('badges.badges')" active>
              <data-table :edit-item="editItem" />
            </b-tab>
            <b-tab @click="newItem={}" :title="$t('site.add')" v-if="user.account_type != 'student'">
              <my-form :new-item="newItem" />
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
  <!-- end of row -->
</template>

<script>
import Auth from '@/Apis/Auth';
 import DataTableVue from "./components/DataTable.vue";
import FormVue from "./components/Form.vue";

export default {
  name: "Badges",
  components: {
    "data-table": DataTableVue,
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tab: 0,
      user:Auth.USER,
    };
  },
  methods: {
    editItem(data) {
      delete this.newItem.introductory_file;
      this.newItem = data.item;

      this.tab = 1;
    },
  },
};
</script>

<style></style>
